module.exports = "<div md-is-locked-open=\"true\" layout-padding>\n    <md-button ng-repeat=\"step in $ctrl.stepsList\"\n               class=\"md-raised md-primary\"\n               ng-class=\"{'md-warn': step.notified, 'md-hue-1': step.clicked, 'md-hue-3': !step.clicked}\"\n               ng-click=\"$ctrl.gotoSelected(step)\"\n               >\n        {{step.name}}\n    </md-button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/evaluation/stepsList/stepsListView.html
// module id = 204
// module chunks = 0